<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-1"></v-divider>
      <div class="pl-5 r-5">
        <div class="h2 grey--text  mb-0">Sub Category Alphabets</div>
        <v-btn
          small
          width="100"
          tile
          color="primary"
          :disabled="is_loading"
          v-for="(alpha, index) in alphabets"
          :key="index"
          :outlined="alpha != selected_alpha"
          @click="go_to_section('sub_categories_alpah_section_' + alpha)"
        >
          <v-icon left>mdi-eye</v-icon>
          {{ alpha }}
        </v-btn>
      </div>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>

    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="crumps"
        title="View Business Category"
        :width_class="page_info.center_width_class"
      ></CenterNavbar>
      <div class="componet-has-nav-bar white pt-5">
        <CardedSectionHeader
          icon="mdi-group"
          label="Category Details"
          id="public_category_details_section"
        ></CardedSectionHeader>
        <CardedDisplay>
          <div class="pa-5">
            <ViewHeader
              :title="category.name"
              :icon="category.icon"
              :img_src="category.thumb_nail"
              :facts="view_header_facts"
              :description="category.description"
            ></ViewHeader>
          </div>
        </CardedDisplay>
        <CardedSectionHeader
          icon="mdi-group"
          label="Sub Categories"
          id="public_category_details_sub_category_section"
        ></CardedSectionHeader>
        <div
          style="min-height: 700px"
          v-if="parseInt(category.sub_categories_count) > 0"
        >
          <v-row
            no-gutters
            v-for="(group, index) in sub_categories"
            :key="index"
          >
            <v-col cols="12">
              <div style="max-width: 150px">
                <CardedSectionHeader
                  icon="mdi-group"
                  :label="index.toUpperCase()"
                  :id="'sub_categories_alpah_section_' + index"
                ></CardedSectionHeader>
              </div>
            </v-col>
            <v-col
              no-gutters
              cols="3"
              v-for="(category, index) in group"
              :key="index"
            >
              <div
                class="elevation-4 ma-2 pointer round-4"
                @click="select_sub_category(category)"
              >
                <div class="grey lighten-4 text-center">
                  <v-img
                    grey
                    :src="category.thumb_nail"
                    width="200"
                    min-width="200"
                    height="200"
                    min-height="200"
                  >
                  </v-img>
                </div>
                <div class="pa-3 text-left">
                  <v-icon>{{ category.icon }}</v-icon>
                  <span
                    class="text-decoration-underlinex primary--text cat-item-text pl-2"
                    >{{ category.name }}
                  </span>
                </div>
                <v-divider></v-divider>
                <div class="pr-2 pl-2 d-flex justify-space-between fs-14">
                  <div calss="text-left">Businesses:</div>
                  <div class="text-right grey--text">
                    <b>{{ comma(category.belongings.length) }}</b>
                  </div>
                </div>
                <v-divider></v-divider>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          //nyd //no big sub categories emogi and message go here
        </div>
        <CardedSectionHeader
          icon="mdi-group"
          label="Businesses In This Category"
          id="public_category_details_businesses_section"
        ></CardedSectionHeader>
        <CardedTable
          :items="businesses"
          :headers="business_headers"
          :show_description="true"
          :has_margin="false"
        >
          <template v-slot:description>
            <p class="text-left ml-4 mr-4">
              This category has {{ businesses.length }} businesses
            </p>
          </template>
          <template v-slot:[`item.description`]="{ item }">
            <div
            style="max-width: 300px; font-size: 13px"
            class="text-left text-truncate"
          >{{item.description}}</div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              @click="view_business(item)"
              x-small
              rounded
              text
              color="success"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </CardedTable>
      </div>

      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";
import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CenterNavbar from "./../../components/CenterNavbar";
import Footer from "./../../components/CenterFooter";
import ViewHeader from "./../../components/ViewHeader";
import CardedDisplay from "./../../components/CardedDisplay";
import CardedTable from "./../../components/CardedTable";
import QuickSideLinks from "./../../components/QuickSideLinks";


import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
export default {
  name: "Category",
  components: {
    Page,
    SidePageColumn,
    FeaturedSidePromotions,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterNavbar,
    Footer,
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    CardedTable,
    QuickSideLinks
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "category_view",
    page_info: page_info,
    category_id: 0,
    category: Utils.get_default_page_category(),
    sub_categories: {},
    businesses: [],
    alphabets: [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ],
    selected_alpha: "a",
    business_headers: [
      { text: "Name", value: "name" },
      { text: "District", value: "district.name", sortable: false },
      { text: "More", value: "description", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
    sub_categories_count: 0,
    quick_links: [
      {
        text: "Category Details",
        href: "#public_category_details_section",
      },
      {
        text: "Sub Categories",
        href: "#public_category_details_sub_category_section",
      },
      {
        text: "Businesses",
        href: "#public_category_details_businesses_section",
      }
    ],
    crumps: []
  }),
  methods: {
    load_category() {
      this.$emit("on-show-loader");
      ServerClient.Categories.fetch_category_page(
        {
          id: this.category_id,
        },
        (res) => {
          this.$emit("on-hide-loader");

          //console.log("this one ", res);

          var sub_categories = res.sub_categories;
          var sc_dict = {};
          var grouping = {};
          for (var index = 0; index < this.alphabets.length; index++) {
            var ch = this.alphabets[index];
            grouping[ch] = [];
          }
          for (var index = 0; index < sub_categories.length; index++) {
            var cat = sub_categories[index];
            var name = cat.name.toLowerCase();
            var ch = name[0];
            grouping[ch].push(cat);
            sc_dict[cat.id] = {
              ch: ch,
              group_index: grouping[ch].length - 1
            };
          }

          
          this.sub_categories = grouping;
          this.category = res.category;
          this.businesses = res.businesses;


          var vm = this;
          setTimeout(() => {
            vm.go_to_section("public_category_details_section");
          }, 1000);
        },
        (errors) => {
          console.log(
            "Errors loading category details on public category page: ",
            errors
          );
          this.$emit("on-hide-loader");
        }
      );
    },
    go_to_section(alpha) {
      this.selected_alpha = alpha;
      this.scroll_to_secton(alpha);
    },
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    select_sub_category(category) {
      this.$router.push("/categories/" + category.category_id + "/sub/" + category.id );
    },
    scroll_to_secton(lmnt_id) {
      try {
        var options = {
          offset: 50,
          duration: 1000,
          easing: "easeInOutCubic",
        };
        this.$vuetify.goTo("#" + lmnt_id, options);
      } catch (error) {
        console.log("Error scrolling to section on categories page ", error);
      }
    },
    view_business(business){
      this.$router.push('/businesses/'+business.id);
    }
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Is A Top Category:",
          val: parseInt(this.category.is_top_category) == 1 ? "Yes" : "No",
        },
        {
          text: "Sub Categories:",
          val: this.comma(this.category.sub_categories_count),
        },
        {
          text: "Businesses :",
          val: this.comma(this.category.businesses_count),
        }
      ];
      return facts;
    },
  },
  mounted() {
    this.category_id = parseInt(this.$route.params.id);
    this.crumps = [{
      text: "Categories",
      disabled: false,
      href: "/categories",
    },{
      text: "View",
      disabled: true,
      href: "/categories/" + this.category_id,
    }];
    this.load_category();
  },
};
</script>